<div class="w-full">
    <div class="p-4">
        <!-- Header -->
        <div class="flex justify-between items-center mb-4">
            <h2 class="text-2xl font-bold">Edit User (Super Admin)</h2>
            <button mat-icon-button (click)="onCancel()" class="text-gray-500 hover:text-gray-700">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
            <!-- Name -->
            <mat-form-field class="w-full mb-3">
                <mat-label>Full Name</mat-label>
                <input matInput formControlName="name" required />
                <mat-error *ngIf="userForm.get('name')?.hasError('required')">
                    Name is required
                </mat-error>
            </mat-form-field>

            <!-- Email -->
            <mat-form-field class="w-full mb-3">
                <mat-label>Email Address</mat-label>
                <input matInput formControlName="email" type="email" />
                <mat-hint>Email cannot be changed after account creation.</mat-hint>
            </mat-form-field>

            <!-- Phone -->
            <mat-form-field class="w-full mb-3">
                <mat-label>Phone Number</mat-label>
                <input matInput formControlName="phone" />
            </mat-form-field>

            <!-- Country -->
            <mat-form-field class="w-full mb-3">
                <mat-label>Country</mat-label>
                <input matInput formControlName="country" />
            </mat-form-field>

            <!-- Language -->
            <mat-form-field class="w-full mb-4">
                <mat-label>Language</mat-label>
                <mat-select formControlName="language">
                    <mat-option value="en">English</mat-option>
                    <mat-option value="ar">Arabic</mat-option>
                    <mat-option value="fr">French</mat-option>
                    <mat-option value="es">Spanish</mat-option>
                    <mat-option value="de">German</mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Actions -->
            <div class="flex justify-end gap-3 mt-4 pt-4 border-t">
                <button mat-button type="button" (click)="onCancel()" [disabled]="isLoading">
                    Cancel
                </button>
                <button
                    mat-flat-button
                    type="submit"
                    color="primary"
                    [disabled]="isLoading || userForm.invalid"
                >
                    <span *ngIf="!isLoading">Save Changes</span>
                    <span *ngIf="isLoading">Saving...</span>
                </button>
            </div>
        </form>
    </div>
</div>
